import {compose, graphql} from 'react-apollo';
import gql from 'graphql-tag';

import NavigationForm from '../components/NavigationForm';
import config from '../config';
import {SaveNavigationMutation, SaveNavigationMutationConfig} from '../qql-shared/mutations';

const NavigationNewQuery = gql`
  query allContents($project: String) {
    allContents(project: $project) {
      _id
      title
      slug
      type
    }
  }
`;
const NavigationNewQueryConfig = {
  options: {variables: {project: config.getProjectKey()}},
};

export default compose(
  graphql(NavigationNewQuery, NavigationNewQueryConfig),
  graphql(SaveNavigationMutation, SaveNavigationMutationConfig)
)(NavigationForm);



// WEBPACK FOOTER //
// ./src/containers/NavigationNew.js